/**
 * Updates the menu based on the current url
 */
export function updateMenu()
{
	//Update the menu aria-current page based on urls
	let url = window.location.href;
	let nav = document.querySelector('.nav');

	//Remove the old current page attributes
	const currentPage = nav.querySelector('li.current-menu-item');

	if(currentPage) {
		const currentPageLink = currentPage.querySelector('a');

		currentPage.classList.remove('current-menu-item');
		currentPageLink.setAttribute('aria-current', '');

		//Find the new current page and add classes
		let activeLink = nav.querySelector(`a[href="${url}"]`);

		if(activeLink) {
			activeLink.setAttribute('aria-current', 'page');
			activeLink.parentNode.classList.add('current-menu-item');
		}
	}
}



// WEBPACK FOOTER //
// ./scripts/modules/update-active-menu.js